/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'gift': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 19',
    data: '<path pid="0" d="M9.778 3.636A1.76 1.76 0 0 0 9.52 2.7L8 0 6.48 2.7a1.76 1.76 0 0 0-.258.936A1.8 1.8 0 0 0 8 5.455a1.8 1.8 0 0 0 1.778-1.819zm1.36 8.927l-.96.973a3.1 3.1 0 0 1-4.347 0l-.951-.973-.969.973a3.019 3.019 0 0 1-2.169.918A3.041 3.041 0 0 1 0 13.9v4.191A.9.9 0 0 0 .889 19h14.222a.9.9 0 0 0 .889-.909V13.9a3.041 3.041 0 0 1-1.742.555 3.019 3.019 0 0 1-2.169-.918zM8.889 8.181V6.363H7.111v1.818H2.667A2.694 2.694 0 0 0 0 10.909v.4a1.765 1.765 0 0 0 1.742 1.782 1.687 1.687 0 0 0 1.227-.518l1.9-1.936 1.893 1.936a1.754 1.754 0 0 0 2.462 0l1.9-1.936 1.893 1.936a1.7 1.7 0 0 0 1.227.518 1.765 1.765 0 0 0 1.742-1.782v-.4a2.681 2.681 0 0 0-2.658-2.727z" fill-rule="evenodd"/>'
  }
})
